export const ZERO_BYTES32 =
  '0x0000000000000000000000000000000000000000000000000000000000000000';
